import React from 'react';
import { Hero } from '../components/home/Hero';
import { Confianza } from '../components/home/Confianza';
import { Testimonios } from '../components/home/Testimonios';
import { QuienesSomos } from '../components/home/QuienesSomos';
import { Servicios } from '../components/home/Servicios';
import { QuickActions } from '../components/home/QuickActions';
import { CatalogoPreview } from '../components/home/CatalogoPreview';
import { SelectorUsados } from '../components/home/selector/SelectorUsados';
import { Oportunidades } from '../components/home/Oportunidades';
import { FinanciacionSection } from '../components/home/FinanciacionSection';
import { VenderSection } from '../components/home/VenderSection';
import { PermutasSection } from '../components/home/PermutasSection';
import { PorQueVcars } from '../components/home/PorQueVcars';
import { Proceso } from '../components/home/Proceso';
import { CtaFinal } from '../components/home/CtaFinal';
import { Section, SectionHeading } from '../components/ui/Section';
import { Reveal } from '../components/ui/Reveal';
import { ConsultaForm } from '../components/forms/ConsultaForm';
import { useSeo } from '../utils/seo';
export function Home() {
  useSeo();
  return <main data-id="element-724" data-mp="2qxu3bla6si08">
      <Hero data-id="element-725" data-mp="2qxkfa38pckx6" />
      <Confianza data-id="element-726" data-mp="2qx0tgbfxlcdv" />
      <Testimonios data-id="element-727" data-mp="2r0oq3jgoaewt" />
      <QuienesSomos data-id="element-728" data-mp="2mx0ferwqv37c" />
      <Servicios data-id="element-729" data-mp="2mxjork8bwj9r" />
      <QuickActions data-id="element-730" data-mp="2mvyvdxxr36dh" />
      <CatalogoPreview data-id="element-731" data-mp="2mwqpf4bp8w1n" />
      <SelectorUsados data-id="element-732" data-mp="2mzctuv3amvfn" />
      <Oportunidades data-id="element-733" data-mp="2hyff6shhsjiw" />
      <FinanciacionSection data-id="element-734" data-mp="2hyywq838d5we" />
      <VenderSection data-id="element-735" data-mp="2hz8fpbpuycsl" />
      <PermutasSection data-id="element-736" data-mp="2hzqg8kjjzd6b" />
      <PorQueVcars data-id="element-737" data-mp="2d6oze6zsd3k3" />
      <Proceso data-id="element-738" data-mp="2d65rzk7rhxkb" />
      <Section id="contacto" data-id="element-739" data-mp="2d5mcsb9hxn9z">
        <Reveal data-id="element-740" data-mp="2d5dw08a95xti">
          <SectionHeading title="Dejá tu consulta" lead="Atención personalizada para encontrar el vehículo ideal. Un asesor te responde en el día." align="center" data-id="element-741" data-mp="287uhr8dk1l1k" />
        </Reveal>
        <Reveal delay={0.05} data-id="element-742" data-mp="1z6ea38e4jx11">
          <div className="mx-auto max-w-3xl" data-id="element-743" data-mp="1z6mjureyam80">
            <ConsultaForm data-id="element-744" data-mp="1u7t8p5n4z7b0" />
          </div>
        </Reveal>
      </Section>
      <CtaFinal data-id="element-745" data-mp="1uap86yemu41k" />
    </main>;
}